var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.tag1 || _vm.user.tag2)?_c('span',{staticClass:"user-tag"},[_vm._v(_vm._s(_vm._f("userTag")(_vm.user)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }